import api from 'ApiConfig';

const overviewService = {
  // Awdiz lms
  getStudentOverview: async () => {
    return api.post('/student/student-practicle-assignment-overview');
  },
  getMcqTestOverview: async () => {
    return api.post('/student/get-mcq-test-overview');
  },
  getQaTestOverview: async () => {
    return api.post('/student/get-qa-test-overview');
  },
  //asignmnet
  getMCQAssignmentOverview: async () => {
    return api.post('/student/get-mcq-assignment-overview');
  },
  getQAAssignmentOverview: async () => {
    return api.post('/student/get-qa-assignment-overview');
  },
  getRemainingTasks: async () => {
    return api.post('/student/get-remaining-tasks');
  },
  getMockTestOverview: async () => {
    return api.post('/student/get-mock-test-overview');
  },
  getFinalMockOverview: async () => {
    return api.post('/student/get-final-mock-overview');
  },
};
export default overviewService;
